import { ApiExternal } from '@/modules/core/app/constants/ApiExternal';
import { apiExternalV1Axios } from '/@/modules/core/app/helpers/AxiosHelper';

export class BaseApiExternalV1Resource {
  async getData<T>(path: string, params: Params = {}, headers = {}): Promise<T> {
    // @ts-ignore
    headers['Authorization'] = `Bearer ${localStorage.getItem(ApiExternal.LOCAL_STORAGE_KEY)}`;
    return apiExternalV1Axios.get(path, { params, headers });
  }

  async postData<T>(path: string, params: Params = {}, headers = {}): Promise<T> {
    // @ts-ignore
    headers['Authorization'] = `Bearer ${localStorage.getItem(ApiExternal.LOCAL_STORAGE_KEY)}`;
    return apiExternalV1Axios.post(path, params, { headers });
  }
}
